

(function () {

    angular.module('tmx-app')
        .controller('managePrivilegesEditCtrl', ['$state','ManagePrivilegesService', 
            function ManagePrivilegesEditCtrl($state,ManagePrivilegesService) {

                var managePrivilegesEditCtrlVM=this;
                managePrivilegesEditCtrlVM.query = "privileges";
                managePrivilegesEditCtrlVM.date = new Date().toJSON();
                managePrivilegesEditCtrlVM.cols = ManagePrivilegesService.filterColumn;
                managePrivilegesEditCtrlVM.schema = ManagePrivilegesService.schema;
                managePrivilegesEditCtrlVM.cloneColumn = ManagePrivilegesService.editGridColumn;
                managePrivilegesEditCtrlVM.ManagePrivilegesService = ManagePrivilegesService;
                managePrivilegesEditCtrlVM.view ="View";
                managePrivilegesEditCtrlVM.edit="Edit";
                managePrivilegesEditCtrlVM.delete="Delete";
                managePrivilegesEditCtrlVM.create="Create";
                managePrivilegesEditCtrlVM.add="Add";
                managePrivilegesEditCtrlVM.assign="Assign";
                managePrivilegesEditCtrlVM.verify="Verify";
                managePrivilegesEditCtrlVM.approve="Approve";
                managePrivilegesEditCtrlVM.promise;
                managePrivilegesEditCtrlVM.dataSource;
                managePrivilegesEditCtrlVM.header={"Checked":false};
                managePrivilegesEditCtrlVM.Privileges=[
                    {
                        "id":"1",
                        "Name":"All Privileges",
                        "Checked":false

                    },
                    {
                        "id":"2",
                        "Name":"View",
                        "Checked":false


                    },
                    {
                        "id":"3",
                        "Name":"Edit",
                        "Checked":false


                    },
                    {
                        "id":"4",
                        "Name":"Delete",
                        "Checked":false


                    },
                    {
                        "id":"5",
                        "Name":"Create",
                        "Checked":false


                    }

                ];
                managePrivilegesEditCtrlVM.TransactionTabPrivileges=[
                    {
                        "id":"1",
                        "Name":"All Privileges",
                        "Checked":false

                    },
                    {
                        "id":"2",
                        "Name":"View",
                        "Checked":false

                    },
                    {
                        "id":"3",
                        "Name":"Edit",
                        "Checked":false

                    },
                    {
                        "id":"4",
                        "Name":"Delete",
                        "Checked":false

                    },
                    {
                        "id":"5",
                        "Name":"Create",
                        "Checked":false

                    },
                    {
                        "id":"6",
                        "Name":"Assign",
                        "Checked":false

                    },
                    {
                        "id":"7",
                        "Name":"Verify",
                        "Checked":false

                    },
                    {
                        "id":"8",
                        "Name":"Approve",
                        "Checked":false

                    }
                ];
                managePrivilegesEditCtrlVM.Entities=[
                    {

                        "EntityName":"Branches",
                        "Checked":false
                    },
                    {
                        "EntityName":"Customers",
                        "Checked":false

                    },
                    {
                        "EntityName":"Company",
                        "Checked":false
                    },
                    {
                        "EntityName":"Devices",
                        "Checked":true
                    },
                    {
                        "EntityName":"Loan Products",
                        "Checked":true
                    },
                    {
                        "EntityName":"Users",
                        "Checked":false
                    }

                ];
                managePrivilegesEditCtrlVM.transactionEntities=[
                    {
                        "TransactionEntityName":"Loan Application"
                    }
                ];
                managePrivilegesEditCtrlVM.toggleCheckerAll =function(checked) {

                    if(checked){
                //managePrivilegesEditCtrlVM.dataSource= $("#grid").data().kendoGrid.dataSource;
                //managePrivilegesEditCtrlVM.dataSource.online(false);


                        for(let i=0;i< managePrivilegesEditCtrlVM.Entities.length;i++){

                    //managePrivilegesEditCtrlVM.dataSource.at(i).set("Checked",true);


                    /*dataSource.data([
                     {
                     EntityName: "1",
                     Checked: true,
                     ViewIcon: "close",
                     EditIcon: "close",
                     DeleteIcon: "close",
                     CreateIcon: "close",
                     }
                     ]);*/

                    // change the ProductName field of the first data item
                    //dataSource.at(0).set("ProductName", "Updated");
                    // sync to accept the changes
                    //dataSource.sync();
                    // get the offline data
                    //var offlineData = dataSource.offlineData();

                    //var v= managePrivilegesEditCtrlVM.mainGridOptions;
                            managePrivilegesEditCtrlVM.Entities[i].Checked=checked;
                        }
                //$("#grid").data("kendoPivotGrid").setDataSource(x);
                //dataSource.sync();
                // managePrivilegesEditCtrlVM.dataSource.online(true);


                    }
                    else{
                        for(let i=0;i<managePrivilegesEditCtrlVM.Entities.length;i++){
                            managePrivilegesEditCtrlVM.Entities[i].Checked=false;
                        }
                    }
                };
                managePrivilegesEditCtrlVM.tabStateChanged=function(name){
                    if(name=="All Privileges"){
                        if(managePrivilegesEditCtrlVM.TransactionTabPrivileges[0].Checked){
                            for(let i=0;i< managePrivilegesEditCtrlVM.TransactionTabPrivileges.length;i++){
                                managePrivilegesEditCtrlVM.TransactionTabPrivileges[i].Checked=true;
                            }
                        }
                        else{
                            for(let i=0;i< managePrivilegesEditCtrlVM.TransactionTabPrivileges.length;i++){
                                managePrivilegesEditCtrlVM.TransactionTabPrivileges[i].Checked=false;
                            }
                        }

                    }
                }
                managePrivilegesEditCtrlVM.stateChanged = function (name) {

                    if(name=="All Privileges"){
                        if(managePrivilegesEditCtrlVM.Privileges[0].Checked){
                            for(let i=0;i< managePrivilegesEditCtrlVM.Privileges.length;i++){
                                managePrivilegesEditCtrlVM.Privileges[i].Checked=true;
                            }
                        }
                        else{
                            for(let i=0;i< managePrivilegesEditCtrlVM.Privileges.length;i++){
                                managePrivilegesEditCtrlVM.Privileges[i].Checked=false;
                            }
                        }

                    }
                    else if(name=="Create"){
                        if(managePrivilegesEditCtrlVM.Privileges[4].Checked){
                            for(let i=1;i< managePrivilegesEditCtrlVM.Privileges.length;i++){
                                managePrivilegesEditCtrlVM.Privileges[i].Checked=true;
                            }
                        }
                        else{
                            for(let i=1;i< managePrivilegesEditCtrlVM.Privileges.length;i++){
                                managePrivilegesEditCtrlVM.Privileges[i].Checked=false;
                            }
                        }
                    }
                    else{
                        if(managePrivilegesEditCtrlVM.Privileges[0].Checked){
                            for(let i=0;i< managePrivilegesEditCtrlVM.Privileges.length;i++){
                                managePrivilegesEditCtrlVM.Privileges[i].Checked=true;
                            }
                        }
                    }
                }

                managePrivilegesEditCtrlVM.onChange=function(checked,item){

                    if(item.EntityName=="Branches"){
                        if(checked){
                            item.Checked=checked;
                        }
                        else
                            item.Checked=checked;

                    }
                    if(item.EntityName=="Customers"){

                        if(checked){
                            item.Checked=checked;

                        }
                        else
                            item.Checked=checked;

                    }
                    if(item.EntityName=="Company"){

                        if(checked){
                            item.Checked=checked;

                        }
                        else
                            item.Checked=checked;

                    }
                    if(item.EntityName=="Devices"){

                        if(checked){
                            item.Checked=checked;

                        }
                        else
                            item.Checked=checked;

                    }
                    if(item.EntityName=="Loan Products"){

                        if(checked){
                            item.Checked=checked;

                        }
                        else
                            item.Checked=checked;


                    }
                    if(item.EntityName=="Users"){

                        if(checked){
                            item.Checked=checked;

                        }
                        else
                            item.Checked=checked;

                    }

                }
                managePrivilegesEditCtrlVM.clickView=function(Item,eventname){

                    if(eventname=='View'){
                        if(Item.ViewIcon=="add_circle"){
                            Item.ViewIcon="close";
                        }
                        else
                            Item.ViewIcon="add_circle";
                    }
                    if(eventname=='Edit'){
                        if(Item.EditIcon=="add_circle"){
                            Item.EditIcon="close";
                        }
                        else
                            Item.EditIcon="add_circle";
                    }
                    if(eventname=='Delete'){
                        if(Item.DeleteIcon=="add_circle"){
                            Item.DeleteIcon="close";
                        }
                        else
                            Item.DeleteIcon="add_circle";
                    }
                    if(eventname=='Create'){
                        if(Item.CreateIcon=="add_circle"){
                            Item.CreateIcon="close";

                        }
                        else
                            Item.CreateIcon="add_circle";
                    }
                    if(eventname=='Add'){

                        if(Item.AddIcon=="add_circle"){
                            Item.AddIcon="close";

                        }
                        else
                            Item.AddIcon="add_circle";
                    }
                    if(eventname=='Assign'){

                        if(Item.AssignIcon=="add_circle"){
                            Item.AssignIcon="close";

                        }
                        else
                            Item.AssignIcon="add_circle";
                    }
                    if(eventname=='Verify'){

                        if(Item.VerifyIcon=="add_circle"){
                            Item.VerifyIcon="close";

                        }
                        else
                            Item.VerifyIcon="add_circle";
                    }
                    if(eventname=='Approve'){

                        if(Item.ApproveIcon=="add_circle"){
                            Item.ApproveIcon="close";

                        }
                        else
                            Item.ApproveIcon="add_circle";
                    }

                };
                managePrivilegesEditCtrlVM.editGridColumn = ManagePrivilegesService.editColumns;
                managePrivilegesEditCtrlVM.filters = {};
                managePrivilegesEditCtrlVM.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function(o){
                                managePrivilegesEditCtrlVM.o = angular.copy(o);
                        // managePrivilegesEditCtrlVM.filters = managePrivilegesEditCtrlVM.o.data.filter;
                                var promise=ManagePrivilegesService.getByParams(o,true);
                                promise.then(function(response){
                                    if(!angular.isDefined(response))return;
                                    response.data=managePrivilegesEditCtrlVM.Entities;


                                    for (let i=0; i<response.data.length; i++){

                                        response.data[i].ViewIcon="add_circle";
                                        response.data[i].EditIcon="add_circle";
                                        response.data[i].DeleteIcon="add_circle";
                                        response.data[i].CreateIcon="add_circle";

                                    }

                                    o.success(response);
                                });
                                return promise;
                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total",

                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },


                    pdf: {
                        allPages: true,
                        fileName: "Companies.pdf"
                    },
                    excel: {
                        allPages: true,
                        fileName: "Companies.xlsx"
                    },

                    sortable: true,
                    scrollable: false,
                    rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': ManagePrivilegesCtrl.isStatusActive(dataItem)}\" >" +

            "<td style='width: 70%'>" +
            "<md-checkbox  aria-label=\"Checkbox No Ink\" class='md-primary'" +
            " ng-model='dataItem.Checked' ng-change='ManagePrivilegesEditCtrl.onChange(dataItem.Checked)'>  {{ ManagePrivilegesCtrl.getPrivilegeName(dataItem)}}   " +
            "<md-tooltip md-direction='top'>#=EntityName#</md-tooltip></md-checkbox>" +
            "</td>" +

            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.view)'>" +
            "<md-icon class='md-accent material-icons menu-list-item' >{{ ManagePrivilegesCtrl.getIcon(dataItem,'View')}}</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.edit)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Edit')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.delete)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Delete')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.create)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Create')}}" +
            "</md-icon></md-button>"+
            "</td>" +


            "</tr>",
            //columns: ManagePrivilegesService.editColumns
                    columns: [

                        {
                            field: "Modules",
                            title: "Modules",
                            headerTemplate:"<md-checkbox  ng-change='ManagePrivilegesEditCtrl.toggleCheckerAll(ManagePrivilegesEditCtrl.header.Checked)' ng-model='ManagePrivilegesEditCtrl.header.Checked' ></md-checkbox><span>Modules </span>"

                        },
                        {
                            field: "View",
                            title: "View",
                            headerTemplate:"<span  >View<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"

                        },


                        {
                            field: "Edit",
                            title: "Edit",
                            headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Edit<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                        },
                        {
                            field: "Delete",
                            title: "Delete",
                            headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Delete<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                        },
                        {
                            field: "Create",
                            title: "Create",
                            headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Create<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                        }
                    ]

                };
        //managePrivilegesEditCtrlVM.editGridColumn = ManagePrivilegesService.editTransactionColumns;
                managePrivilegesEditCtrlVM.filters = {};
                managePrivilegesEditCtrlVM.transactionGridOptions = {
                    dataSource: {
                        transport: {
                            read: function(o){
                                managePrivilegesEditCtrlVM.o = angular.copy(o);
                                managePrivilegesEditCtrlVM.filters = managePrivilegesEditCtrlVM.o.data.filter;
                                var promise=ManagePrivilegesService.getByParams(o,true);
                                promise.then(function(response){
                                    if(!angular.isDefined(response))return;
                                    response.data=managePrivilegesEditCtrlVM.transactionEntities;
                                    for (let i=0; i<response.data.length; i++){
                                        response.data[i].ViewIcon="add_circle";
                                        response.data[i].EditIcon="add_circle";
                                        response.data[i].DeleteIcon="add_circle";
                                        response.data[i].AddIcon="add_circle";
                                        response.data[i].AssignIcon="add_circle";
                                        response.data[i].VerifyIcon="add_circle";
                                        response.data[i].ApproveIcon="add_circle";
                                    }

                                    o.success(response);
                                });
                                return promise;
                            },

                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total",
                        },
                //serverPaging: true,
                //serverFiltering: true,
                //serverSorting: true,
                    },

                    pdf: {
                        allPages: true,
                        fileName: "Companies.pdf"
                    },
                    excel: {
                        allPages: true,
                        fileName: "Companies.xlsx"
                    },

                    sortable: true,
                    scrollable: false,
                    rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': ManagePrivilegesCtrl.isStatusActive(dataItem)}\" >" +

            "<td>" +
            "<md-checkbox  aria-label=\"Checkbox No Ink\" class='md-primary'" +
            " ng-model='ManagePrivilegesEditCtrl.Privileges[dataItem].Checked'>  {{ ManagePrivilegesCtrl.getTransactionEntityName(dataItem)}}   " +
            "<md-tooltip md-direction='top'>#=TransactionEntityName#</md-tooltip></md-checkbox>" +
            "</td>" +

            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.view)'>" +
            "<md-icon class='md-accent material-icons menu-list-item' >{{ ManagePrivilegesCtrl.getIcon(dataItem,'View')}}</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.edit)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Edit')}}" +
            "</md-icon></md-button>"+
            "</td>" +
                //
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.delete)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Delete')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.add)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Add')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.assign)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Assign')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.verify)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Verify')}}" +
            "</md-icon></md-button>"+
            "</td>" +
            "<td>" +
            "<md-button  aria-label='del' class='tmxMin' ng-click='ManagePrivilegesEditCtrl.clickView(dataItem,ManagePrivilegesEditCtrl.approve)'>" +
            "<md-icon class='md-accent material-icons menu-list-item'>{{ ManagePrivilegesCtrl.getIcon(dataItem,'Approve')}}" +
            "</md-icon></md-button>"+
            "</td>" +

            "</tr>",
                    columns: ManagePrivilegesService.editTransactionColumns

                };

                managePrivilegesEditCtrlVM.container = {};
                $state.data={
                    grid: managePrivilegesEditCtrlVM.container,
                    info: false
                };


            }]);
})();

